export default __webpack_public_path__ + "static/media/diuQuiz.845d6c19.webp";